import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { API_BASE_URL, INSET_CUSTOMER, GET_CUSTOMERS } from "../../../Config";
import Axios from "axios";
import PropTypes from "prop-types";
import SpinLoader from "../../../feature-module/loader/SpinLoader";

const CustomerModal = ({ customerObj }) => {
  const [userDataSession, setUserDataSession] = useState(null);
  const [viewEditCustomerData, setViewEditCustomerData] = useState(null);
  const [loading, setLoading] = useState(false);

 
  const parseToYYYYMMDD = (dateStr) => {
    if (!dateStr) return "";
 
    const ddmmyyyyMatch = dateStr.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (ddmmyyyyMatch) {
      const [, day, month, year] = ddmmyyyyMatch;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
 
    const isomatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isomatch) {
      return dateStr.split("T")[0]; 
    }
    return dateStr;
  };

  const formatToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const yyyyMMDD = parseToYYYYMMDD(dateStr);
    const date = new Date(yyyyMMDD);
    if (isNaN(date.getTime())) return dateStr;
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const match = dateStr.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (match) {
      const year = parseInt(match[3], 10);
      if (year <= 1990) {
        return dateStr;
      }
    }
    return formatToDDMMYYYY(dateStr);
  };

  // #region Session for userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const [editFormData, setEditFormData] = useState(null);

  useEffect(() => {
    if (userDataSession) {
      setEditFormData({
        orgid: Number(userDataSession.OrgId),
        userid: Number(userDataSession.UserId),
        Customer: {
          Id: 0,
          Name: "",
          Email: "",
          Mobile: "",
          Notes: "",
          DOB: "",
          Anniversary: "",
          CardNumber: "",
          Amount: 0,
          EmpType: 0,
          IsPostPaidAllowed: false,
          CustGroupId: 0,
          IsActive: true,
          GSTIN: "",
        },
        Address: {
          Id: 0,
          Name: "",
          Mobile: "",
          AddressType: "Office",
          HouseNo: "",
          ApartmentName: "",
          AreaName: "",
          LandMark: "",
          City: "",
          State: "",
          Country: "India",
          PinCode: "",
          Longitude: 0,
          Latitude: 0,
          IsActive: true,
        },
      });
    }
  }, [userDataSession]);

  const [editAddressType, setEditAddressType] = useState("Office");
  const [editSubmitBtnLoading, setEditSubmitBtnLoading] = useState(false);

  const handleEditAddressSelectChange = (event) => {
    const value = event.target.value;
    setEditAddressType(value);
    if (editFormData) {
      setEditFormData((prev) => ({
        ...prev,
        Address: { ...prev.Address, AddressType: value },
      }));
    }
  };

  // #region Getting View data from ID
  useEffect(() => {
    if (customerObj?.Id && userDataSession?.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_CUSTOMERS}?OrgId=${userDataSession.OrgId}&CustomerId=${customerObj.Id}`
      )
        .then((response) => {
          if (response.data.Status && response.data.ResultData.length > 0) {
            setViewEditCustomerData(response.data.ResultData[0]);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setViewEditCustomerData([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setViewEditCustomerData([]);
          setLoading(false);
        });
    }
  }, [customerObj?.Id, userDataSession?.OrgId]);

  const handleEditInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = value;
    if (type === "checkbox") {
      finalValue = checked;
    } else if (
      ["number", "PinCode"].includes(type) ||
      name.includes("Amount") ||
      name.includes("EmpType") ||
      name.includes("CustGroupId") ||
      name.includes("Latitude") ||
      name.includes("Longitude")
    ) {
      finalValue = value === "" ? 0 : Number(value);
    }
    const [objectName, key] = name.split(".");
    if (objectName && key && editFormData) {
      setEditFormData((prevState) => ({
        ...prevState,
        [objectName]: {
          ...prevState[objectName],
          [key]: finalValue,
        },
      }));
    } else if (editFormData) {
      setEditFormData((prevState) => ({
        ...prevState,
        [name]: finalValue,
      }));
    }
  };

  // #region Edit customer func
  const handleEditSubmit = (e) => {
    console.log("handle edit clicked");
    e.preventDefault();
    if (!editFormData) return;
    setEditSubmitBtnLoading(true);

    const payload = {
      ...editFormData,
      Customer: {
        ...editFormData.Customer,
        DOB: formatToDDMMYYYY(editFormData.Customer.DOB),
        Anniversary: formatToDDMMYYYY(editFormData.Customer.Anniversary),
      },
    };
  
    payload.orgid = Number(userDataSession.OrgId);
    payload.userid = Number(userDataSession.UserId);

    console.log(payload, "data sending to api");

    Axios.post(`${API_BASE_URL}${INSET_CUSTOMER}`, payload)
      .then((response) => {
        setEditSubmitBtnLoading(false);
        if (response.data[0]?.Success === 1) {
          Swal.fire({
            title: "Customer updated Successfully.",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: response.data[0]?.Message || "Failed to update customer.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setEditSubmitBtnLoading(false);
        console.error("Error updating customer:", error);
        Swal.fire({
          title: "Error",
          text: "An error occurred while updating the customer.",
          icon: "error",
        });
      });
  };

  // Populate edit form when viewEditCustomerData changes
  useEffect(() => {
    if (viewEditCustomerData && userDataSession) {
      const newEditFormData = {
        orgid: Number(userDataSession.OrgId),
        userid: Number(userDataSession.UserId),
        Customer: {
          Id: viewEditCustomerData.CustomerId || 0,
          Name: viewEditCustomerData.CustomerName || "",
          Email: viewEditCustomerData.Email || "",
          Mobile: viewEditCustomerData.Mobile || "",
          Notes: viewEditCustomerData.Notes || "",
          DOB: viewEditCustomerData.DOB
            ? parseToYYYYMMDD(viewEditCustomerData.DOB)
            : "",
          Anniversary: viewEditCustomerData.Anniversary
            ? parseToYYYYMMDD(viewEditCustomerData.Anniversary)
            : "",
          CardNumber: viewEditCustomerData.CardNumber || "",
          Amount: Number(viewEditCustomerData.Amount) || 0,
          EmpType: parseInt(viewEditCustomerData.EmpType) || 0,
          IsActive:
            viewEditCustomerData.IsActive !== undefined
              ? Boolean(viewEditCustomerData.IsActive)
              : true,
          GSTIN: viewEditCustomerData.GSTIN || "",
          IsPostPaidAllowed:
            viewEditCustomerData.IsPostPaidAllowed !== undefined
              ? Boolean(viewEditCustomerData.IsPostPaidAllowed)
              : false,
          CustGroupId: parseInt(viewEditCustomerData.CustGroupId) || 0,
        },
        Address: {
          Id: viewEditCustomerData.AddressId || 0,
          Name: viewEditCustomerData.AddressName || "",
          Mobile:
            viewEditCustomerData.AddressMobile ||
            viewEditCustomerData.Mobile ||
            "",
          AddressType: viewEditCustomerData.AddressType || "Office",
          HouseNo: viewEditCustomerData.HouseNo || "",
          ApartmentName: viewEditCustomerData.ApartmentName || "",
          AreaName: viewEditCustomerData.AreaName || "",
          LandMark: viewEditCustomerData.LandMark || "",
          City: viewEditCustomerData.City || "",
          State: viewEditCustomerData.State || "",
          Country: "India",
          PinCode: Number(viewEditCustomerData.PinCode) || "",
          Longitude: Number(viewEditCustomerData.Longitude) || 0,
          Latitude: Number(viewEditCustomerData.Latitude) || 0,
          IsActive:
            viewEditCustomerData.AddressIsActive !== undefined
              ? Boolean(viewEditCustomerData.AddressIsActive)
              : true,
        },
      };
      setEditFormData(newEditFormData);
      setEditAddressType(viewEditCustomerData.AddressType || "Office");
    }
  }, [viewEditCustomerData, userDataSession]); 



  if (!userDataSession) return null;

  return (
    <>
      {loading && <SpinLoader />}
      {/* Edit Customer */}
      <div
        className="modal fade"
        id="edit-units"
        // data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-modal-two mt-5"
          style={{ maxWidth: "70%" }}
        >
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Customer</h4>
                  </div>
                  <button
                    type="button"
                    className="close d-flex ms-auto"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div
                  className="modal-body custom-modal-body"
                  style={{ height: "520px" }}
                >
                  <ul
                    className="nav nav-tabs tab-style-2 nav-justified mb-3 d-sm-flex d-block"
                    id="myTab1"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="order-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#order-tab-pane-edit"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                      >
                        <i className="fa-regular fa-address-book me-1 align-middle"></i>
                        Personal Info
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="shipped-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#shipped-tab-pane-edit"
                        type="button"
                        role="tab"
                        aria-controls="contact-tab-pane"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-house-user me-1 align-middle"></i>
                        Address
                      </button>
                    </li>
                  </ul>
                  <form onSubmit={handleEditSubmit}>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="order-tab-pane-edit"
                        role="tabpanel"
                        aria-labelledby="home-tab-1"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Customer.Name"
                                value={editFormData?.Customer.Name || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter customer name"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Email</label>
                              <input
                                type="email"
                                className="form-control"
                                name="Customer.Email"
                                value={editFormData?.Customer.Email || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter email"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Phone</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Customer.Mobile"
                                value={editFormData?.Customer.Mobile || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter phone no"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Date Of Birth</label>
                              <input
                                type="date"
                                className="form-control"
                                name="Customer.DOB"
                                value={
                                  getDisplayDate(editFormData?.Customer.DOB) ||
                                  ""
                                }
                                onChange={handleEditInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Anniversary</label>
                              <input
                                type="date"
                                className="form-control"
                                name="Customer.Anniversary"
                                value={
                                  getDisplayDate(
                                    editFormData?.Customer.Anniversary
                                  ) || ""
                                }
                                onChange={handleEditInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Card Number</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Customer.CardNumber"
                                value={editFormData?.Customer.CardNumber || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter card number"
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="input-blocks">
                              <label>Notes</label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="Customer.Notes"
                                value={editFormData?.Customer.Notes || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter notes..."
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>GSTIN</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Customer.GSTIN"
                                value={editFormData?.Customer.GSTIN || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter GSTIN"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 d-none">
                            <div className="input-blocks">
                              <label>Is Active</label>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name="Customer.IsActive"
                                  id="editCustomerIsActive"
                                  checked={
                                    editFormData?.Customer.IsActive || false
                                  }
                                  onChange={handleEditInputChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="editCustomerIsActive"
                                >
                                  Active
                                </label>
                              </div>
                            </div>
                          </div>
                          {/* Hidden fields remain hidden */}
                          <div className="col-lg-4 d-none">
                            <div className="input-blocks">
                              <label>Employee Type</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Customer.EmpType"
                                value={editFormData?.Customer.EmpType || 0}
                                onChange={handleEditInputChange}
                                placeholder="Enter EmpType (e.g., 0)"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 d-none">
                            <div className="input-blocks">
                              <label>Is Post Paid Allowed</label>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name="Customer.IsPostPaidAllowed"
                                  id="editIsPostPaidAllowed"
                                  checked={
                                    editFormData?.Customer.IsPostPaidAllowed ||
                                    false
                                  }
                                  onChange={handleEditInputChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="editIsPostPaidAllowed"
                                >
                                  Post Paid Allowed
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 d-none">
                            <div className="input-blocks">
                              <label>Customer Group ID</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Customer.CustGroupId"
                                value={editFormData?.Customer.CustGroupId || 0}
                                onChange={handleEditInputChange}
                                placeholder="Enter CustGroupId"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="tab-pane fade"
                        id="shipped-tab-pane-edit"
                        role="tabpanel"
                        aria-labelledby="contact-tab"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Country</label>
                              <input
                                type="text"
                                className="form-control"
                                value="India"
                                style={{ cursor: "not-allowed" }}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>House No</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address.HouseNo"
                                value={editFormData?.Address.HouseNo || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter HouseNo"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Area</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address.AreaName"
                                value={editFormData?.Address.AreaName || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter area name"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Appartment</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address.ApartmentName"
                                value={
                                  editFormData?.Address.ApartmentName || ""
                                }
                                onChange={handleEditInputChange}
                                placeholder="Enter appartment name"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>City</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address.City"
                                value={editFormData?.Address.City || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter city"
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>State</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address.State"
                                value={editFormData?.Address.State || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter state"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>ZipCode</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Address.PinCode"
                                value={editFormData?.Address.PinCode || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter pincode"
                              />
                            </div>
                          </div>

                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Landmark</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address.LandMark"
                                value={editFormData?.Address.LandMark || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter landmark"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Address Type</label>
                              <select
                                className="form-select"
                                value={editAddressType}
                                onChange={handleEditAddressSelectChange}
                              >
                                <option value="Office">Office</option>
                                <option value="Residential">Residential</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Address Mobile</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Address.Mobile"
                                value={editFormData?.Address.Mobile || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter address mobile"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 d-none">
                            <div className="input-blocks">
                              <label>Address Is Active</label>
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  name="Address.IsActive"
                                  id="editAddressIsActive"
                                  checked={
                                    editFormData?.Address.IsActive || false
                                  }
                                  onChange={handleEditInputChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="editAddressIsActive"
                                >
                                  Active
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Latitude</label>
                              <input
                                type="number"
                                step="any"
                                className="form-control"
                                name="Address.Latitude"
                                value={editFormData?.Address.Latitude || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter latitude"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Longitude</label>
                              <input
                                type="number"
                                step="any"
                                className="form-control"
                                name="Address.Longitude"
                                value={editFormData?.Address.Longitude || ""}
                                onChange={handleEditInputChange}
                                placeholder="Enter longitude"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        disabled={editSubmitBtnLoading}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-submit"
                        disabled={editSubmitBtnLoading}
                      >
                        {editSubmitBtnLoading ? "Submitting..." : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Customer */}

      {/* View Customer */}
      <div
        className="modal fade"
        id="view-units"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-modal-two mt-5"
          style={{ maxWidth: "70%" }}
        >
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>View Customer</h4>
                  </div>
                  <button
                    type="button"
                    className="close d-flex ms-auto"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div
                  className="modal-body custom-modal-body"
                  style={{ height: "520px" }}
                >
                  <ul
                    className="nav nav-tabs tab-style-2 nav-justified mb-3 d-sm-flex d-block"
                    id="myTab1"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="order-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#order-tab-pane-view"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                      >
                        <i className="fa-regular fa-address-book me-1 align-middle"></i>
                        Personal Info
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="shipped-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#shipped-tab-pane-view"
                        type="button"
                        role="tab"
                        aria-controls="contact-tab-pane"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-house-user me-1 align-middle"></i>
                        Address
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="order-tab-pane-view"
                      role="tabpanel"
                      aria-labelledby="home-tab-1"
                      tabIndex={0}
                    >
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.CustomerName || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Email</label>
                            <input
                              type="email"
                              className="form-control"
                              value={viewEditCustomerData?.Email || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Phone</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.Mobile || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Date Of Birth</label>
                            <input
                              type="text"
                              className="form-control"
                              value={
                                viewEditCustomerData?.DOB
                                  ? getDisplayDate(viewEditCustomerData.DOB)
                                  : ""
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Anniversary</label>
                            <input
                              type="text"
                              className="form-control"
                              value={
                                viewEditCustomerData?.Anniversary
                                  ? getDisplayDate(
                                      viewEditCustomerData.Anniversary
                                    )
                                  : ""
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Card Number</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.CardNumber || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="input-blocks">
                            <label>Notes</label>
                            <textarea
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.Notes || ""}
                              readOnly
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>GSTIN</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.GSTIN || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Is Active</label>
                            <input
                              type="text"
                              className="form-control"
                              value={
                                viewEditCustomerData?.IsActive ? "Yes" : "No"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 d-none">
                          <div className="input-blocks">
                            <label>Employee Type</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.EmpType || 0}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 d-none">
                          <div className="input-blocks">
                            <label>Is Post Paid Allowed</label>
                            <input
                              type="text"
                              className="form-control"
                              value={
                                viewEditCustomerData?.IsPostPaidAllowed
                                  ? "Yes"
                                  : "No"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 d-none">
                          <div className="input-blocks">
                            <label>Customer Group ID</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.CustGroupId || 0}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="shipped-tab-pane-view"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                      tabIndex={0}
                    >
                      <div className="row">
                        <div className="col-lg-4 col-sm-10 col-10">
                          <div className="input-blocks">
                            <label>Country</label>
                            <input
                              type="text"
                              className="form-control"
                              value="India"
                              style={{ cursor: "not-allowed" }}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-10 col-10">
                          <div className="input-blocks">
                            <label>House No</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.HouseNo || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Area</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.AreaName || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Appartment</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.ApartmentName || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-10 col-10">
                          <div className="input-blocks">
                            <label>City</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.City || ""}
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-10 col-10">
                          <div className="input-blocks">
                            <label>State</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.State || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>ZipCode</label>
                            <input
                              type="number"
                              className="form-control"
                              value={viewEditCustomerData?.PinCode || ""}
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Landmark</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.LandMark || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Address Type</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.AddressType || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Address Mobile</label>
                            <input
                              type="text"
                              className="form-control"
                              value={
                                viewEditCustomerData?.AddressMobile ||
                                viewEditCustomerData?.Mobile ||
                                ""
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 d-none">
                          <div className="input-blocks">
                            <label>Address Is Active</label>
                            <input
                              type="text"
                              className="form-control"
                              value={
                                viewEditCustomerData?.AddressIsActive
                                  ? "Yes"
                                  : "No"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Latitude</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.Latitude || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="input-blocks">
                            <label>Longitude</label>
                            <input
                              type="text"
                              className="form-control"
                              value={viewEditCustomerData?.Longitude || ""}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /View Customer */}
    </>
  );
};

CustomerModal.propTypes = {
  customerObj: PropTypes.object,
};

export default CustomerModal;
